export default __webpack_public_path__ + "static/media/check-up-mobile.51bc6f4d.png";